import React, { useState, useEffect } from 'react';
import { db } from '../../../firebase';
import { doc, updateDoc, increment, onSnapshot } from 'firebase/firestore';
import '../MarsTheme.css';

const VisitorCounter = () => {
    const [count, setCount] = useState(20845); // Fallback / Loading state

    useEffect(() => {
        const docRef = doc(db, "cms", "portfolio_v1");
        const sessionKey = 'mars_visit_logged';

        const initCounter = async () => {
            // 1. Increment if new session
            if (!sessionStorage.getItem(sessionKey)) {
                // Prevent double-counting in React StrictMode by setting immediately
                sessionStorage.setItem(sessionKey, 'true');

                try {
                    await updateDoc(docRef, {
                        visitorCount: increment(1)
                    });
                } catch (err) {
                    console.error("Error updating visitor count:", err);
                    // Optional: sessionStorage.removeItem(sessionKey); // Retry next time?
                }
            }
        };

        initCounter();

        // 2. Real-time Listener (always get fresh count)
        const unsubscribe = onSnapshot(docRef, (doc) => {
            if (doc.exists() && doc.data().visitorCount) {
                setCount(doc.data().visitorCount);
            }
        });

        return () => unsubscribe();
    }, []);

    return (
        <div className="visitor-counter glass-panel fade-in">
            <span className="counter-label">Mission Observers</span>
            <span className="counter-value">{count.toLocaleString()}</span>
        </div>
    );
};

export default VisitorCounter;
